import React, {useRef} from 'react';
import {Toast, ToastSeverityType} from "primereact/toast";
import ProductTemplateTable from "../../dashboard/product-template-table/ProductTemplateTable";

type ProductTemplateProps = {
    safeName: string
    filter?: string
    dateFrom: Date
    dateTo: Date
    transposed:boolean
}

const ProductTemplatePreview = ({safeName, filter, dateFrom, dateTo, transposed}: ProductTemplateProps) => {
    const myToast = useRef<Toast>(null);

    const onFetchError = (er: string) => {
        const showToast = (severityValue: ToastSeverityType, summaryValue: string, detailValue: string) => {
            myToast.current!.show({severity: severityValue, summary: summaryValue, detail: detailValue});
        }
        showToast("error", "Error while fetching", er)
    }

    return <>
        <ProductTemplateTable safeName={safeName}
                              filter={filter}
                              showTitle={false}
                              onFetchError={onFetchError}
                              retry={false}
                              exactDateFrom={dateFrom}
                              exactDateTo={dateTo}
                              hideDates={true}
                              transposed={transposed}
                              itemsPerPage={10}
                              useExternalFilterEndpoint={true}
        />
        <Toast ref={myToast}></Toast>
    </>

};

export default ProductTemplatePreview;